import {
  ALGOLIA_NEURAL_SEARCH,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import { getExperiment } from 'shared/experiments/utils/experiments'
import { type Experiment } from 'types/shopConfig'

export const getAlgoliaNeuralSearchIndexIfEnabled = (
  experiments: Experiment[] = [],
  indexName: string
): string => {
  const neuralSearchExperiment = getExperiment(
    ALGOLIA_NEURAL_SEARCH,
    experiments
  )

  // if neural search is enabled and the index is a product index, we need to add the KW_ prefix
  if (
    neuralSearchExperiment?.isEnabled &&
    neuralSearchExperiment?.variant === EXPERIMENT_VARIATION.V1 &&
    indexName.startsWith('product')
  ) {
    return 'KW_' + indexName
  }

  return indexName
}
